import React from 'react'
import { List as AntList } from 'antd'
import { ListProps } from './props'

export const List: React.FC<ListProps<any>> = (props) => {
    return <AntList {...props} />
}
